import { AdditionalFieldKey, AdditionalFieldsModel } from '../model';

export const shouldSaveDerivedField = (
  prevValue: AdditionalFieldsModel[AdditionalFieldKey] | undefined,
  nextValue: AdditionalFieldsModel[AdditionalFieldKey] | undefined,
): boolean => {
  const prevIsNullish = prevValue === null || prevValue === undefined;
  const nextIsNullish = nextValue === null || nextValue === undefined;

  if (prevIsNullish && nextIsNullish) {
    return false;
  }

  if (typeof prevValue === 'number' && typeof nextValue === 'number') {
    return prevValue !== nextValue;
  }

  return prevValue !== nextValue;
};
